export default __webpack_public_path__ + "static/media/snapshot_camera_button.c103ba02.png";